import { useIntl } from 'react-intl'

function useCruiseCabinTypeLabels(): Record<string, string> {
  const intl = useIntl()

  return {
    Inside: intl.formatMessage({
      id: '72QqjZCke5oBB-HcECtE',
      defaultMessage: 'Inside',
      description: 'Cruise cabin type label for inside cabins in the cruise section',
    }),
    Oceanview: intl.formatMessage({
      id: 'k_Hyng8RpDx8AC_bzoRp',
      defaultMessage: 'Oceanview',
      description: 'Cruise cabin type label for oceanview cabins in the cruise section',
    }),
    Window: intl.formatMessage({
      id: 'gNvTfbVukSlmHhvwHmtn',
      defaultMessage: 'Window',
      description: 'Cruise cabin type label for window cabins in the cruise section',
    }),
    'Oceanview / Window': intl.formatMessage({
      id: 'MEVgbDckrM9Xik866TYb',
      defaultMessage: 'Oceanview / Window',
      description: 'Cruise cabin type label for combined oceanview and window cabins',
    }),
    Balcony: intl.formatMessage({
      id: '-xfsOUNadb-OjfKBKMEq',
      defaultMessage: 'Balcony',
      description: 'Cruise cabin type label for balcony cabins in the cruise section',
    }),
    Suite: intl.formatMessage({
      id: 'Qww5jccxAce2gj0eZAzC',
      defaultMessage: 'Suite',
      description: 'Cruise cabin type label for suite cabins in the cruise section',
    }),
  }
}

export default useCruiseCabinTypeLabels
